import { clearApiClient } from './clearApiClient';

export interface APICouponResponse {
  coupon_code: string;
  coupon_dicount_percent: number;
  created_at: string;
  updated_at: string;
}

export const fetchCoupon = () =>
  clearApiClient
    .post<{ coupon: APICouponResponse | null }>('/web/v1/store/coupon/get-account-coupon')
    .then((response) => response.data);

interface RedeemCouponResponse {
  isValid: boolean;
  type: 'unknown_universal_code' | 'promocode_universal_code' | 'coupon_universal_code' | 'referrer_universal_code';
  couponPayUrl?: string;
}

export const redeemCouponToProfile = (code: string) =>
  clearApiClient
    .post<RedeemCouponResponse>('/web/v1/store/promocode/universal/redeem', { code })
    .then((response) => response.data);
